// Event data extracted from the Philippines National Cyber Resilience Forum brochure
export const EVENT = {
  name: "Philippines National Cyber Resilience Forum",
  shortName: "NATCYRES PHIL 2026",
  tagline: "Government–Industry Collaboration for Cyber Resilience",
  dates: "17 – 18 November 2026",
  dateShort: "Nov 17–18, 2026",
  venue: "Manila, Philippines",
  domain: "www.natcyresphil.com",
  organizer: "Convergence Experts",
  emails: {
    info: "info@convex.events",
    speaker: "speaker@convex.events",
  },
};

export const SPEAKERS = [
  { name: "Henry R. Aguda", title: "Secretary", org: "DICT" },
  { name: "Gilberto C. Teodoro, Jr.", title: "Secretary", org: "Department of National Defense" },
  { name: "Usec. Rodil Aniban", title: "OIC-Undersecretary for Cybersecurity", org: "DICT" },
  { name: "Renato \"Aboy\" Paraiso", title: "Undersecretary & Acting Exec. Director", org: "Cybercrime Investigation and Coordination Center" },
  { name: "Atty. Johann Carlos S. Barcena", title: "Privacy Commissioner & Chairman", org: "National Privacy Commission" },
  { name: "George Erwin Garcia", title: "Chairperson", org: "Commission on Elections" },
  { name: "Lt. Col. Rodrigo F. Quinto", title: "Deputy Director, C2 Center", org: "Philippine Army Cyber Battalion" },
  { name: "PCol Jay Guillermo", title: "Chief, Cyber Response Unit", org: "PNP Anti-Cybercrime Group" },
  { name: "George P. Tardio", title: "Director", org: "National CERT (NCERT/CERT-PH)" },
  { name: "Engr. Gerald Talusig", title: "Representative", org: "CERT-PH" },
  { name: "Marilene P. Tayag", title: "CISO", org: "Meralco" },
  { name: "Francisco Castillo", title: "SVP & CIO", org: "Maynilad Water Services" },
  { name: "Jim Allan Alcantara", title: "CISO", org: "Manila International Airport Authority" },
  { name: "Rene Morta", title: "CIO & Head of IT", org: "BDO" },
  { name: "Maricris A. Salud", title: "Cybersecurity Lead", org: "Bangko Sentral ng Pilipinas" },
  { name: "Ingrid Beroña", title: "Chief Risk Officer", org: "GCash" },
  { name: "Renato K. De Borja, Jr.", title: "Executive Vice President", org: "Metrobank" },
  { name: "Alexander S. Tined", title: "IT Director", org: "St. Luke's Medical Center" },
  { name: "Bently D. Roxas", title: "CISO", org: "Department of Health" },
  { name: "Sonny Angara", title: "IT Representative", org: "Department of Education" },
  { name: "Roderic V. Ilagan", title: "Information Technology Officer", org: "COMELEC" },
  { name: "Angeli B. Belen", title: "Head of Training", org: "DICT" },
  { name: "Julius Gorospe", title: "Cybersecurity Budget Specialist", org: "DICT" },
  { name: "Atty. Dennis S. Santiago", title: "Director", org: "Government Procurement Expert" },
  { name: "Alexis Bernardino", title: "Field CISO & Head of CXO Advisory", org: "PLDT Group" },
  { name: "Dr. William Emmanuel Yu", title: "CTO & Professor", org: "Novare Technologies / Ateneo de Manila" },
  { name: "Rathi Pragasam", title: "Managing Director", org: "London Prestige Group" },
];

export const AGENDA = {
  day1: {
    label: "Day 1",
    date: "Tuesday, 17 November 2026",
    theme: "Threat Landscape & National Priorities",
    sessions: [
      {
        time: "08:00 – 08:45",
        title: "Registration & Networking Breakfast",
        type: "Break",
      },
      {
        time: "08:45 – 09:15",
        title: "Opening Ceremony",
        type: "Ceremony",
      },
      {
        time: "08:45 – 09:00",
        title: "Welcome Remarks",
        type: "Remarks",
        speaker: "Organizer — Convergence Experts",
      },
      {
        time: "09:00 – 09:15",
        title: "Opening Keynote: The State of Cybersecurity in the Philippines — National Imperatives",
        type: "Keynote",
        speaker: "Henry R. Aguda, Secretary, DICT",
      },
      {
        time: "09:15 – 09:55",
        title: "Panel: Defending the Digital Republic — Nation-State Threats & Geopolitical Realities",
        type: "Panel Discussion",
        moderator: "Independent cybersecurity analyst / journalist",
        panelists: [
          "Lieutenant Colonel Rodrigo F. Quinto — Deputy Director, Command and Control Center, Philippine Army Cyber Battalion",
          "PCol Jay Guillermo — Chief, Cyber Response Unit, PNP Anti-Cybercrime Group",
          "Vendor Company — Regional Threat Intelligence Lead",
          "Engr. Gerald Talusig — Representative, CERT-PH",
        ],
      },
      {
        time: "09:55 – 10:25",
        title: "Presentation",
        type: "Presentation",
        speaker: "Vendor Company",
      },
      {
        time: "10:25 – 10:55",
        title: "Coffee Break & Networking",
        type: "Break",
        description: "Sponsor activation: Technology showcase demos.",
      },
      {
        time: "10:55 – 11:35",
        title: "Panel: Critical Infrastructure Protection — Lessons from Energy, Water & Transport",
        type: "Panel Discussion",
        moderator: "Infrastructure security consultant",
        panelists: [
          "Marilene P. Tayag — CISO, Meralco",
          "Francisco Castillo — SVP and CIO, Maynilad Water Services, Inc.",
          "Jim Allan Alcantara — CISO, Manila International Airport Authority",
          "Vendor — OT Security Specialist",
        ],
      },
      {
        time: "11:35 – 12:05",
        title: "Case Study: Defending a Government Agency — Real Cyber Incident Response",
        type: "Case Study",
        speaker: "Joint Presentation",
        panelists: [
          "George Erwin Garcia — Chairperson, Commission on Elections",
          "Incident response partner (Vendor)",
        ],
      },
      {
        time: "12:05 – 13:15",
        title: "Networking Lunch",
        type: "Break",
        description: "Roundtable discussions hosted by sponsors.",
      },
      {
        time: "13:15 – 13:55",
        title: "Panel: Financial Sector Under Siege — Banking Cybersecurity in 2026",
        type: "Panel Discussion",
        moderator: "Banking industry analyst",
        panelists: [
          "Rene Morta — CIO and Head of IT, BDO",
          "Maricris A. Salud — Cybersecurity Lead, Bangko Sentral ng Pilipinas (BSP)",
          "Ingrid Beroña — Chief Risk Officer, GCash",
          "Vendor Company — Banking Security Solutions",
        ],
      },
      {
        time: "13:55 – 14:25",
        title: "Presentation: AI-Powered Threats — Deepfakes, Automated Attacks & Defense Strategies",
        type: "Presentation",
        speaker: "AI Security Researcher — Vendor Company",
        topics: [
          "Generative AI used by attackers",
          "Deepfake scams targeting executives",
          "AI-driven phishing at scale",
          "Using AI for defense (threat detection, anomaly analysis)",
        ],
      },
      {
        time: "14:25 – 15:05",
        title: "Panel: Healthcare & Education Sectors — Protecting Sensitive Data",
        type: "Panel Discussion",
        moderator: "Healthcare IT consultant",
        panelists: [
          "Alexander S. Tined — IT Director, St. Luke's Medical Center",
          "Bently D. Roxas — CISO, Department of Health",
          "Sonny Angara — DepEd IT Representative, Department of Education",
          "Vendor Company — Healthcare Security Specialist",
        ],
      },
      {
        time: "15:05 – 15:35",
        title: "Coffee Break & Technology Showcase",
        type: "Break",
        description: "Sponsor demos and product presentations.",
      },
      {
        time: "15:35 – 16:05",
        title: "Presentation: Implementing Multi-Factor Authentication at Scale — Government Playbook",
        type: "Presentation",
        speaker: "Vendor Company",
      },
      {
        time: "16:05 – 16:45",
        title: "Panel: Ransomware Resilience — Prevention, Detection & Recovery",
        type: "Panel Discussion",
        moderator: "Cybersecurity consultant",
        panelists: [
          "Government agency that recovered from ransomware (if willing to share)",
          "Vendor Company — Ransomware Response Lead",
          "Vendor Company — Backup & Recovery Specialist",
          "Cyber Insurance Representative — Insurance company",
        ],
      },
      {
        time: "16:45 – 17:00",
        title: "Day 1 Closing & Networking Reception Preview",
        type: "Closing",
      },
      {
        time: "17:00 – 18:30",
        title: "Networking Reception",
        type: "Reception",
      },
    ],
  },
  day2: {
    label: "Day 2",
    date: "Wednesday, 18 November 2026",
    theme: "Solutions, Collaboration & Action",
    sessions: [
      {
        time: "08:30 – 09:00",
        title: "Networking Breakfast & Day 1 Recap",
        type: "Break",
      },
      {
        time: "09:00 – 09:10",
        title: "Day 2 Opening — From Awareness to Action",
        type: "Remarks",
      },
      {
        time: "09:10 – 09:50",
        title: "Panel: Public–Private Partnerships — Intelligence Sharing & Coordinated Defense",
        type: "Panel Discussion",
        moderator: "Former DICT official or cybersecurity policy expert",
        panelists: [
          "George P. Tardio — Director, National CERT (NCERT/CERT-PH)",
          "Alexis Bernardino — Field CISO and Head of CXO Advisory, PLDT Group (representing private sector ISPs)",
          "Rathi Pragasam — Managing Director, London Prestige Group International Strategy & Stakeholder Relations",
          "Renato \"Aboy\" Paraiso — Undersecretary and Acting Executive Director, Cybercrime Investigation and Coordination Center",
        ],
      },
      {
        time: "09:50 – 10:20",
        title: "Case Study: Securing Elections — COMELEC's Cybersecurity Journey",
        type: "Case Study",
        speaker: "Joint Presentation",
        panelists: [
          "Roderic V. Ilagan — Information Technology Officer, COMELEC (Commission on Elections)",
          "Security Partner (partner of COMELEC)",
        ],
      },
      {
        time: "10:20 – 10:50",
        title: "Presentation: Zero Trust Architecture for Government — Implementation Roadmap",
        type: "Presentation",
        speaker: "Solutions Architect — Vendor Company",
      },
      {
        time: "10:50 – 11:20",
        title: "Coffee Break & Vendor Consultations",
        type: "Break",
        description: "One-on-one booth meetings.",
      },
      {
        time: "11:20 – 12:00",
        title: "Panel: Budgeting for Cybersecurity — Getting Executive & Legislative Buy-In",
        type: "Panel Discussion",
        moderator: "Government budget analyst or consultant",
        panelists: [
          "Usec. Rodil Aniban — OIC-Undersecretary for Cybersecurity, DICT",
          "Julius Gorospe — Cybersecurity Budget Specialist, DICT",
          "V Atty. Dennis S. Santiago — Director, Government Procurement Expert",
          "Renato K. De Borja, Jr. — Executive Vice President, Metropolitan Bank & Trust Co. (Metrobank)",
        ],
      },
      {
        time: "12:00 – 12:30",
        title: "Presentation: Workforce Development — Building the Next Generation of Cyber Defenders",
        type: "Presentation",
        speaker: "Angeli B. Belen — Head of Training, DICT",
      },
      {
        time: "12:30 – 13:30",
        title: "Networking Lunch — Hosted Roundtables by Sector",
        type: "Break",
        topics: [
          "Table 1: Energy & Utilities",
          "Table 2: Healthcare",
          "Table 3: Financial Services",
          "Table 4: Education & Local Government",
          "Table 5: National Security Agencies",
        ],
      },
      {
        time: "13:30 – 14:10",
        title: "Panel: Cloud Security — Government Data Sovereignty & Compliance",
        type: "Panel Discussion",
        moderator: "Cloud security consultant",
        panelists: [
          "Atty. Johann Carlos S. Barcena — Privacy Commissioner and Chairman, National Privacy Commission",
          "Cloud Security Lead — Vendor Company",
          "Henry Aguda — Secretary, DICT",
          "Kimberly Licudine — Senior Associate, PwC",
        ],
      },
      {
        time: "14:10 – 14:40",
        title: "Case Study: Defending a Telecommunications Network — Lessons from PLDT/Smart",
        type: "Case Study",
        speaker: "Joint Presentation",
        panelists: [
          "Alexis Bernardino — Field CISO and Head of CXO Advisory, PLDT Group",
          "Technology Partner — Vendor Company",
        ],
      },
      {
        time: "14:40 – 15:10",
        title: "Coffee Break & Final Networking",
        type: "Break",
      },
      {
        time: "15:10 – 15:50",
        title: "Interactive Workshop: Building Your Agency's Cybersecurity Roadmap",
        type: "Workshop",
        speaker: "Facilitators: Lead Consultant — Vendor Company; Table Facilitators — Mix of government and private sector experts",
        topics: [
          "Attendees grouped by sector (5-6 per table)",
          "Receive templates and frameworks",
          "Work through risk assessment exercise",
          "Prioritize initiatives (quick wins vs long-term)",
          "Identify budget and resource needs",
          "Present 3-minute summary to room",
          "Takeaway: Customized roadmap template to take back to agency",
        ],
      },
      {
        time: "15:50 – 16:30",
        title: "Panel: 2026–2030 — The Future of Philippine Cybersecurity",
        type: "Panel Discussion",
        moderator: "Technology journalist or industry analyst",
        panelists: [
          "Henry R. Aguda — Secretary, DICT (return for closing)",
          "Major Cybersecurity Vendor",
          "Dr. William Emmanuel Yu — Chief Technology Officer, Novare Technologies, Inc. and professor at Ateneo de Manila University",
          "Cybersecurity startup founder (Startup Company)",
          "ASEAN Cyber Capacity Programme Representative",
        ],
      },
      {
        time: "16:30 – 16:50",
        title: "Closing Keynote: Cyber Resilience — From Strategy to National Imperative",
        type: "Keynote",
        speaker: "Gilberto C. Teodoro, Jr. — Secretary, Department of National Defense",
      },
      {
        time: "16:50 – 17:00",
        title: "Closing Remarks & Certificates",
        type: "Closing",
      },
    ],
  },
};

export const AUDIENCE = [
  "Chief Information Security Officers",
  "Government Undersecretaries & Directors",
  "Military & Law Enforcement Leadership",
  "Heads of IT & Digital Transformation",
  "Data Protection Officers",
  "Critical Infrastructure Operators",
  "Financial Sector Risk Leaders",
  "Healthcare & Education IT Directors",
  "Cyber Policy & Regulation Experts",
  "Solution Providers & System Integrators",
];

export const WHY_PH_POINTS = [
  { k: "Rising Threat Volume", v: "Sharp increase in cyber incidents targeting government and critical sectors." },
  { k: "Strategic Digital Push", v: "Nationwide digital transformation across finance, healthcare, and public services." },
  { k: "Policy Momentum", v: "National Cybersecurity Plan 2023–2028 with expanded DICT funding." },
  { k: "Regional Hub", v: "Emerging Southeast Asian hub for cybersecurity innovation & talent." },
];
